module.exports = __webpack_public_path__ + "img/IMG_6347.6f77883f.jpg";